export default {
    agricultorReducer: {
        agricultorObject: null
    },

    motoristaReducer: {
        motoristaObject: null
    },

    pesagemReducer: {
        pesagemObject: {}
    },

    logradouroReducer: {
        logradouroObject: null
    },

    cidadeReducer: {
        cidadeObject: null
    },

    transportadoraReducer: {
        transportadoraObject: null
    },

    veiculoReducer: {
        veiculoObject: null
    },
    
    vinculoTransporteReducer: {
        vinculoTransporteObject: null
    },
    
    fazendaReducer: {
        fazendaObject: null
    },

    produtoReducer: {
        produtoObject: null
    },

    tipoServicoReducer: {
        tipoServicoObject: null
    },

    tipoPagamentoReducer: {
        tipoPagamentoObject: null
    },

    codeReducer: {
        codeObject: null
    },

    balancaReducer: {
        balancaObject: null
    },

    loginReducer: {
        loginObject: null
    },

    messageResponseReducer: {
        messages: [],
        messageSuccess: null
    },

    apiReducer: {
        chamadaApiEmProgresso: 0,
        isLoading: false
    }
};
